import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentListGroupByLocation } from '../../../store/messageInbox/actions';
import { useNavigate } from 'react-router-dom';
//import Reschedule from '../../../assets/admin/reschedule.svg';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker'
import { customBrowserTimeFormat, formatBrowserDate, getLocalTimeZone } from '../../../components/common/DateTimeFormatter';
import { calculateDateDiff } from '../../../helpers/formatterHelper';
import Pause from '../../../assets/pause.png'
function Appointments() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ appointmentDatetime: new Date(), appointmentTimeZone: getLocalTimeZone() });
    const { appointmentDetailList } = useSelector(state => state.inboxlists);

    const [distinctAppointmentTimes, setDistinctAppointmentTimes] = useState([]);
    const [appointmentDatetime, setAppointmentDatetime] = useState("");

    const AppointmentStatusList = {
        QUESTION: 0,
        PAUSED: 1,
        RESCHEDULED: 2,
        CONFIRMED: 3,
        NORESPONSE: 4
    };

    const updateUrlWithDate = (date) => {
        const params = new URLSearchParams(window.location.search);
        params.set('appointmentDatetime', date);
        window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
    };
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setAppointmentDatetime(params.get('appointmentDatetime'));

        if (appointmentDatetime) {
            const parsedDate = new Date(appointmentDatetime);

            if (!isNaN(parsedDate.getTime())) {
                setAppointmentDatetime(appointmentDatetime);
                setFilter({ ...filter, appointmentDatetime: parsedDate });
            } else {
                console.error('Invalid appointmentDatetime parameter:', appointmentDatetime);
            }
        } 
    }, [appointmentDatetime]);


    useEffect(() => {
        dispatch(getAppointmentListGroupByLocation(filter));
    }, [filter]);

    useEffect(() => {
        const times = appointmentDetailList.reduce((acc, location) => {
            location.Appointments?.forEach(appointment => {
                const time = appointment.AppointmentDateTime;
                // Check if time is a valid date string before pushing it
                if (time && !isNaN(new Date(time).getTime()) && !acc.includes(time)) {
                    acc.push(time);
                }
            });
            return acc;
        }, []);
        const sortedTimes = times && times.sort((a, b) => new Date(a) - new Date(b));

        setDistinctAppointmentTimes(sortedTimes);
    }, [appointmentDetailList]);

    const handleStartDateChange = (date) => {
        if (date instanceof Date && !isNaN(date.getTime())) {
            setFilter({ ...filter, appointmentDatetime: date });
            updateUrlWithDate(date);
        }
    };

    const handlePrevDay = () => {
        const prevDay = new Date(filter.appointmentDatetime);
        prevDay.setDate(prevDay.getDate() - 1);
        setFilter({ ...filter, appointmentDatetime: prevDay });
        updateUrlWithDate(prevDay);
    };

    const handleNextDay = () => {
        const nextDay = new Date(filter.appointmentDatetime);
        nextDay.setDate(nextDay.getDate() + 1);
        setFilter({ ...filter, appointmentDatetime: nextDay });
        updateUrlWithDate(nextDay);
    };

    return (
        <>
            <div className="admin-page-wrap appointments-page-wrap">
                <div className="container">
                    <div className="pageContainer">
                        <div className="admin-page-content pt-0">
                            <div>
                                <div className="admin-page-title-wrap">
                                    <h1 className="admin-page-heading">Appointments</h1>
                                    <div className="appointment-date-picker-wrap">
                                        <CustomDatePicker
                                            className="admin-default-input-text"
                                            selected={filter.appointmentDatetime}
                                            placeholder="mm/dd/yyyy"
                                            autoComplete="off"
                                            onChange={handleStartDateChange}
                                            handlePrevDay={handlePrevDay}
                                            handleNextDay={handleNextDay}
                                        />
                                    </div>
                                </div>

                                <div className="position-relative appointments-table-section">
                                    <div className="pt appointments-table-wrapper">
                                        <table className="admin-table">
                                            <tbody>
                                                <tr className="sticky-row bg-grey">
                                                    {appointmentDetailList && appointmentDetailList.map((item, index) => (
                                                        <th key={index} className="admin-table-name-cell">{item.Name}</th>
                                                    ))}
                                                </tr>
                                                {distinctAppointmentTimes && distinctAppointmentTimes.map((time, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td colSpan={appointmentDetailList && appointmentDetailList?.length || 10} className="appointment-date-row">
                                                                <div className="date-td-row">
                                                                    <span className="date-column bg-grey light-grey">{customBrowserTimeFormat(time)}</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            {appointmentDetailList && appointmentDetailList.map((location, lindex) => (
                                                                <td key={lindex}>
                                                                    {location.Appointments.filter(appointment => appointment.AppointmentDateTime === time).map((appointment, aindex) => {
                                                                        const { yearsDiff, monthsDiff } = calculateDateDiff(appointment?.Patients?.[0]?.DateOfBirth);

                                                                        return (
                                                                            <div key={aindex} className="appointment-card" onClick={() => navigate('/history/' + appointment?.Patients?.[0]?.PhoneNumberId)}>
                                                                                <div className="mr-5">
                                                                                    <p className="customer-name color-black">{appointment?.Patients?.[0]?.FirstName} {appointment?.Patients?.[0]?.LastName}</p>
                                                                                    <p className="appointment-date light-grey">DOB: {appointment?.Patients?.[0]?.DateOfBirth && (formatBrowserDate(appointment?.Patients?.[0]?.DateOfBirth) ?? '')}   {`${yearsDiff && yearsDiff + 'y' || ''} ${monthsDiff && monthsDiff + 'mo' || ''}`}</p>
                                                                                </div>
                                                                                <div className="appointment-icon-wrap">
                                                                                    {(() => {
                                                                                        if (appointment.AppointmentStatusId === AppointmentStatusList.QUESTION || appointment.AppointmentStatusId === AppointmentStatusList.NORESPONSE) {
                                                                                            return (
                                                                                                <div className="appointment-mark question-mark">
                                                                                                    <span className="material-symbols-outlined light-grey">
                                                                                                        question_mark
                                                                                                    </span>
                                                                                                </div>
                                                                                            );
                                                                                        } else if (appointment.AppointmentStatusId === AppointmentStatusList.CONFIRMED) {
                                                                                            return (
                                                                                                <div>
                                                                                                    <div className="appointment-mark appointment-success">
                                                                                                        <span className="material-symbols-rounded color-white">
                                                                                                            done
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    {appointment?.UpdatedBy?.toLowerCase() === "emr" && (
                                                                                                        <span className="EMR">EMR</span>
                                                                                                    )}

                                                                                                </div>
                                                                                            );
                                                                                        } else if (appointment.AppointmentStatusId === AppointmentStatusList.RESCHEDULED) {
                                                                                            return (
                                                                                                <div className="appointment-icon-wrap flex-center align-start">
                                                                                                    {/*<div className="appointment-mark">*/}
                                                                                                    {/*    <img src={Reschedule} alt="reschedule" className="reschedule d-inline-flex mr-5" />*/}
                                                                                                    {/*</div>*/}
                                                                                                    <div>
                                                                                                    <div className="appointment-mark appointment-schedule">
                                                                                                        <span className="material-symbols-outlined color-white">
                                                                                                            schedule
                                                                                                        </span>
                                                                                                        </div>
                                                                                                        {appointment?.UpdatedBy?.toLowerCase() === "emr" && (
                                                                                                            <span className="EMR">EMR</span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                    
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                        else if (appointment.AppointmentStatusId === AppointmentStatusList.PAUSED) {
                                                                                            return (
                                                                                                <div>
                                                                                                    <div className="appointment-mark appointment-pause">
                                                                                                        <img src={Pause} alt="pause" />
                                                                                                    </div>
                                                                                                    {appointment?.UpdatedBy?.toLowerCase() === "emr" && (
                                                                                                        <span className="EMR">EMR</span>
                                                                                                    )}
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                        else {
                                                                                            return (
                                                                                                <div>
                                                                                                    <div className="appointment-mark appointment-cancel">
                                                                                                        <span className="material-symbols-outlined color-white">
                                                                                                            close
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    {appointment?.UpdatedBy?.toLowerCase() === "emr" && (
                                                                                                        <span className="EMR">EMR</span>
                                                                                                    )}
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    })()}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    </React.Fragment>
                                                ))}

                                                {appointmentDetailList && appointmentDetailList.length === 0 && <tr><td>No Appointments to show for this Date</td></tr>}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Appointments;
